export default __webpack_public_path__ + "static/media/hht1_home_img_EP12.1d0099cd.png";